import { CircularProgress, Dialog, DialogContent } from "@mui/material";

import Suspense from "@/components/molecules/Suspense";
import { PaymentType } from "@/interfaces/payment-type.interface";
import { PaymentTypeMessages } from "@/messages/platforms/talk2PayHome/payment-type.messages";

import { PaymentTypeFormData } from "../../form-data";
import PaymentTypeForm from "../paymentTypeForm";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  messages: PaymentTypeMessages;
  isLoading: boolean;
  selected?: PaymentType | null;
  onSubmit: (values: PaymentTypeFormData) => void;
}

export const PaymentTypeDialog = ({
  isOpen,
  onClose,
  messages,
  isLoading,
  selected,
  onSubmit,
}: Props) => {
  const isEditing = !!selected;

  return (
    <Dialog open={isOpen} onClose={onClose} sx={{ p: 5 }} fullWidth maxWidth="md">
      <DialogContent>
        <Suspense isSuspended={false} fallback={<CircularProgress size={50} />}>
          <PaymentTypeForm
            messages={messages}
            isEditing={isEditing}
            initial={selected ?? null}
            onCancel={onClose}
            onSubmit={onSubmit}
            isLoading={isLoading}
          />
        </Suspense>
      </DialogContent>
    </Dialog>
  );
};
